<template>
  <div class="my-lg-12 my-md-12 my-sm-12 my-0">
    <v-layout style="margin-bottom: 8rem" class="justify-center">
      <!-- Desktop size -->
      <v-flex lg8 md9 sm10 xs12 v-if="$vuetify.breakpoint.smAndUp">
        <v-layout mt-6 mb-2 class="justify-center">
          <v-flex class="shrink mx-4 flex-center">
            <v-layout>
              <!-- icon star -->
              <v-flex class="d-flex justify-center">
                <v-icon style="font-size: 3.5rem" color="#FFCD18">star</v-icon>
              </v-flex>

              <!-- title top rank  -->
              <v-flex class="d-flex justify-center align-center">
                <v-layout class="column">
                  <v-flex class="font-weight-bold" style="font-size: 46px">
                    Top Rank
                  </v-flex>
                  <v-flex class="flex-center mt-n2 font-weight-bold">
                    {{ $t("toprank-home") }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- filter category  -->
        <v-layout class="justify-center my-6">
          <v-flex xs4>
            <v-select
              hide-details
              v-model="defaultSelected"
              placeholder="หมวดหมู่"
              color="#FD5246"
              outlined
              dense
              flat
              menu-props="offset-y"
              :items="cate_list"
              item-value="id"
              :item-text="$i18n.locale === 'th' ? 'name_th' : 'name_en'"
              @change="getTopRank"
            />
          </v-flex>
        </v-layout>

        <v-layout class="mt-12">
          <v-flex class="text-start">
            <span style="font-size: 24px;font-weight: bold">
              TOP 20 Most Viewed Portfolio
            </span>
          </v-flex>
          <v-flex lg2 md3 sm2 xs3 class="text-center">
            <span style="font-size: 24px;font-weight: bold">View</span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="lg8 md7 sm8 xs7">
            <span>20 อันดับ Portfolio ที่มียอดวิวสูงสุด</span>
          </v-flex>
        </v-layout>

        <v-divider class="my-3"></v-divider>

        <div v-for="(item, i) in top_ranks" :key="i">
          <v-layout class="justify-space-between">
            <v-flex class="lg10 md7 sm8 xs7 my-1">
              <v-layout>
                <v-flex
                  class="shrink mr-12"
                  style="cursor:pointer;"
                  @click="goToDesigner(item)"
                >
                  <v-img
                    width="50"
                    height="50"
                    :src="
                      item.profile && item.profile.mem_info
                        ? checkImage(item.profile.mem_info, 'avatar')
                        : require('../assets/user_profile.png')
                    "
                    style="border-radius: 50%"
                  />
                </v-flex>

                <v-flex class="d-flex align-center">
                  <div>
                    <v-layout>
                      <v-flex
                        :style="
                          $vuetify.breakpoint.mdAndUp
                            ? { 'font-size': '16px' }
                            : { 'font-size': '14px' }
                        "
                        class="on-hover"
                        @click="goToDesigner(item)"
                      >
                        {{ i + 1 }}.
                        {{
                          item.profile &&
                          item.profile.name_th &&
                          item.profile.last_th
                            ? item.profile.name_th + " " + item.profile.last_th
                            : item.profile.email
                        }}
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              class="lg2 md3 sm2 xs3 text-center pt-4"
              :style="
                $vuetify.breakpoint.mdAndUp
                  ? { 'font-size': '16px' }
                  : { 'font-size': '14px' }
              "
            >
              <span>{{ item.sum_view ? item.sum_view : 0 }} view</span>
            </v-flex>
          </v-layout>

          <v-divider class="my-3"></v-divider>
        </div>
        <v-layout mt-12 class="justify-center" v-if="top_ranks.length === 10">
          <v-flex shrink>
            <v-btn width="150" outlined color="#FD5246" @click="getMore">
              <span>{{ $t("more") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Mobile size -->
      <v-flex v-else class="px-5">
        <v-layout mb-2 class="justify-center" style="position: relative">
          <v-flex shrink mx-4>
            <v-layout>
              <!-- icon star -->
              <v-flex class="d-flex justify-center">
                <v-icon style="font-size: 3.5rem" color="#FFCD18">star</v-icon>
              </v-flex>

              <!-- title top rank  -->
              <v-flex class="d-flex justify-center align-center">
                <v-layout class="column">
                  <v-flex class="font-weight-bold" style="font-size: 46px">
                    Top Rank
                  </v-flex>
                  <v-flex class="flex-center mt-n2 font-weight-bold">
                    {{ $t("toprank") }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout mb-6 mt-12 class="justify-center">
          <v-flex xs9>
            <v-select
              hide-details
              v-model="defaultSelected"
              placeholder="หมวดหมู่"
              color="#FD5246"
              outlined
              dense
              flat
              menu-props="offset-y"
              :items="cate_list"
              item-value="id"
              :item-text="$i18n.locale === 'th' ? 'name_th' : 'name_en'"
              @change="getTopRank"
            />
          </v-flex>
        </v-layout>

        <v-layout class="mt-6">
          <v-flex class="text-start">
            <span style="font-size: 18px;font-weight: bold">
              TOP 20 Most Viewed Portfolio
            </span>
          </v-flex>
          <v-flex lg2 md3 sm2 xs3 class="text-end">
            <span style="font-size: 18px;font-weight: bold">Rating</span>
          </v-flex>
        </v-layout>
        <v-layout class="mb-12">
          <v-flex>
            <span style="font-size: 14px;">
              20 อันดับ Portfolio ที่มียอดวิวสูงสุด
            </span>
          </v-flex>
        </v-layout>

        <!-- Top rank list  -->
        <div v-for="(item, i) in top_ranks" :key="i">
          <v-layout class="justify-space-between">
            <v-flex>
              <v-layout>
                <!-- image  -->
                <v-flex
                  class="mr-2 my-2 justify-start d-flex align-center"
                  style="cursor:pointer;"
                  @click="goToDesigner(item)"
                >
                  <v-img
                    width="55"
                    height="55"
                    :src="
                      item.profile && item.profile.mem_info
                        ? checkImage(item.profile.mem_info, 'avatar')
                        : require('../assets/user_profile.png')
                    "
                    style="border-radius: 80%"
                  />
                </v-flex>

                <v-flex
                  class="xs7 px-4 justify-start d-flex align-center"
                  @click="goToDesigner(item)"
                  style="font-size: 14px;word-break: break-all;"
                >
                  {{ i + 1 }}.
                  {{
                    item.profile && item.profile.name_th && item.profile.last_th
                      ? item.profile.name_th + " " + item.profile.last_th
                      : item.profile.email
                  }}
                </v-flex>

                <!-- view total -->
                <v-flex
                  class="xs3 justify-end d-flex align-center"
                  style="font-size: 14px"
                >
                  <span>{{ item.sum_view ? item.sum_view : 0 }} view</span>
                </v-flex>
              </v-layout>
            </v-flex>

            <!-- view total -->
            <!-- <v-flex xs3 class="justify-end d-flex align-center">
              <span>{{ item.sum_view ? item.sum_view : 0 }} view</span>
            </v-flex> -->
          </v-layout>

          <v-divider class="my-3"></v-divider>
        </div>

        <v-layout mt-12 class="justify-center" v-if="top_ranks.length === 10">
          <v-flex shrink>
            <v-btn width="150" outlined color="#FD5246" @click="getMore">
              <span>{{ $t("more") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </div>
</template>

<script>
import { domain, imgPath } from "../services/Constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "TopRank",
  components: {
    Loading,
  },
  data: () => ({
    top_ranks: [],
    imgPath: imgPath,
    url: domain,
    isLoading: false,
    fullPage: true,
    sort: "desc",
    data_toprank: [],
    category_id: null,
    defaultSelected: {
      id: 0,
      name_th: "ทุกหมวดหมู่",
      name_en: "All Category",
    },
    cate_list: [
      {
        id: 0,
        name_th: "ทุกหมวดหมู่",
        name_en: "All Category",
      },
    ],
  }),
  async created() {
    this.isLoading = true;
    await Promise.all([
      this.getCategory(),
      this.getTopRank(0),
      this.$store.dispatch("portfolio/clearActiveMenuCate", 3),
    ]);
    this.isLoading = false;
  },
  methods: {
    getCategory() {
      this.$store
        .dispatch("Categoty/getCategory")
        .then((res) => {
          res.data.categories_list.forEach((data) => {
            this.cate_list.push({
              id: data.id,
              name_th: data.name_th,
              name_en: data.name_en,
            });
          });
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    async getTopRank(category_id) {
      this.isLoading = true;
      this.top_ranks = [];
      var data = {
        category_id: category_id,
        sort: this.sort,
      };
      const res = await this.$store
        .dispatch("portfolio/getTopRank", data)
        .then((res) => {
          this.data_toprank = res.portfolios;
          this.category_id = res.category_id;
          if (res.portfolios.length <= 10) {
            this.top_ranks = res.portfolios;
          } else {
            for (var i = 0; i < 10; i++) {
              this.top_ranks.push(res.portfolios[i]);
            }
          }
          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    getMore() {
      this.isLoading = true;
      for (var i = 10; i < this.data_toprank.length; i++) {
        this.top_ranks.push(this.data_toprank[i]);
      }
      this.isLoading = false;
    },
    getSortTopRank() {
      switch (this.sort) {
        case "desc":
          this.isLoading = true;
          this.sort = "asc";
          let asc = {
            category_id: this.category_id,
            sort: this.sort,
          };
          this.top_ranks = [];
          this.$store.dispatch("portfolio/getSortTopRank", asc).then((res) => {
            this.data_toprank = res.portfolios;
            for (var i = 0; i < 10; i++) {
              this.top_ranks.push(res.portfolios[i]);
            }
            this.isLoading = false;
          });
          break;
        case "asc":
          this.isLoading = true;
          this.sort = "desc";
          let desc = {
            category_id: this.category_id,
            sort: this.sort,
          };
          this.top_ranks = [];
          this.$store.dispatch("portfolio/getSortTopRank", desc).then((res) => {
            this.data_toprank = res.portfolios;
            for (var i = 0; i < 10; i++) {
              this.top_ranks.push(res.portfolios[i]);
            }
            this.isLoading = false;
          });
          break;
      }
    },
    viewPortDetail(port) {
      // let slug =
      //   port.profile.mem_info && port.profile.mem_info.domain_name
      //     ? port.profile.mem_info.domain_name
      //     : port.profile.profile_id;
      // this.$router.push({
      //   path: `/detail-portfolio/${slug}`,
      //   query: { id: port.portfolio_id, pfid: port.profile.profile_id },
      // });
      let domain_slug =
        port.profile.mem_info && port.profile.mem_info.domain_name
          ? port.profile.mem_info.domain_name
          : port.profile.profile_id;
      this.$router.push({
        path: `/profile/${domain_slug}/${port.portfolio_id}`,
      });
    },
    goToDesigner(item) {
      this.$store.dispatch("portfolio/clearActiveMenuCate", 2);
      // this.$router.push({
      //   name: "AllPortfolioByDesign",
      //   query: { profile_id: id },
      // });
      this.$router.push({
        path: `/profile/${
          item.profile.mem_info && item.profile.mem_info.domain_name
            ? item.profile.mem_info.domain_name
            : item.profile.profile_id
        }`,
      });
    },
    checkImage(val, type) {
      if (val) {
        switch (type) {
          case "avatar":
            if (val.avatar) {
              return this.url + this.imgPath + "images_profile/" + val.avatar;
            } else {
              if (this.image_profile_facebook) {
                return this.image_profile_facebook;
              } else {
                return require("../assets/user_profile.png");
              }
            }
            break;
          case "cover_url":
            return val.cover_url
              ? this.url +
                  this.imgPath +
                  "images_profile_cover/" +
                  val.cover_url
              : require("../assets/cover.png");
            break;
        }
      } else {
        return require("../assets/user_profile.png");
      }
    },
    checkName(val) {
      if (val.name_th && val.last_th) {
        if (val.name_th.length > 15) {
          return val.name_th.length > 20
            ? val.name_th.slice(0, 15) + " . . . . "
            : val.name_th;
        } else {
          return (
            val.name_th +
            " " +
            (val.last_th.length > 25
              ? val.last_th.slice(0, 20) + " . . . . "
              : val.last_th)
          );
        }
      } else if (val.name_th && !val.last_th) {
        return val.name_th;
      } else if (val.name_en && val.last_en) {
        if (val.name_en.length > 15) {
          return val.name_en.length > 20
            ? val.name_en.slice(0, 15) + " . . . . "
            : val.name_en;
        } else {
          return (
            val.name_en +
            " " +
            (val.last_en.length > 25
              ? val.last_en.slice(0, 20) + " . . . . "
              : val.last_en)
          );
        }
      } else if (val.name_en && !val.last_en) {
        return val.name_en;
      } else {
        return val.email;
      }
    },
  },
};
</script>

<style scoped>
.on-hover:hover {
  color: #fd5246;
  cursor: pointer;
}
</style>
